import React, { forwardRef, useMemo } from 'react';
import { Loader, LoaderProps } from './Loader';
import { Spinner, SpinnerProps } from './Spinner';

export interface ProgressBaseProps {
  /**
   * Determine if loader, or spinner should be used
   * @default spinner
   */
  variant?: 'spinner' | 'loader';
}

export interface ProgressLoaderProps extends ProgressBaseProps, LoaderProps {
  variant: 'loader';
}

export interface ProgressSpinnerProps extends ProgressBaseProps, SpinnerProps {
  variant?: 'spinner';
}

export type ProgressProps = ProgressLoaderProps | ProgressSpinnerProps;

export const Progress: React.FC<ProgressProps> = forwardRef(({ variant = 'spinner', value, ...rest }, ref) => {
  // make sure the value is valid
  const validValue = useMemo(() => {
    const processedValue = value;
    if (processedValue && processedValue < 0) return 0;
    if (processedValue && processedValue > 100) return 100;
    return processedValue;
  }, [value]);

  if (variant === 'loader') {
    return <Loader ref={ref} value={validValue} {...(rest as LoaderProps)} />;
  }
  return <Spinner ref={ref} value={validValue} {...(rest as SpinnerProps)} />;
});
